import {useMutation} from '@tanstack/react-query';
import axios from 'axios';

const getCookieValue = (name: string) =>
    document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop() ?? '';

export const login = () => {
    const safeUrl = encodeURIComponent(window.location.href);
    window.open(
        `${import.meta.env.HAL_LEGACY_URL}/accounts/login/?next=${safeUrl}`,
        '_self',
    );
};

export const logout = () => {
    const safeUrl = encodeURIComponent(window.location.href);
    window.open(
        `${
            import.meta.env.HAL_LEGACY_URL
        }/accounts/logout/?next=/accounts/login/?next=${safeUrl}`,
        '_self',
    );
};

export const useRefreshToken = () =>
    useMutation(() =>
        axios.post('auth/refresh/', null, {
            headers: {'X-CSRFToken': getCookieValue('csrftoken')},
        }),
    );

export const useOrganization = () =>
    useMutation(
        ({
            organizationId,
            centerId,
        }: {
            organizationId: number;
            centerId?: number;
        }) => axios.post('users/session/', {centerId, organizationId}),
    );
